// extracted by mini-css-extract-plugin
module.exports = {"heading":"multi-content-block-module--heading--7epK6","subHeading":"multi-content-block-module--sub-heading--hbNUK"};